import { useFormContext } from 'react-hook-form';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { TossPaymentMethod } from '../../../../../consts';
import { useUnknownErrorDialog } from '../../../../../hooks/useUnknownErrorDialog';
import { SingularSubscriptionPaymentPaypleCallbackUrl, SingularSubscriptionPaymentTossSuccessCallbackUrl } from '../../../../../services';
import { BusinessPaymentLayout } from '../../../business/BusinessPaymentLayout';
import { usePayple } from '../../hooks/usePayple';
import { PlanCheckoutFormSchemaType } from '../hooks/usePlanCheckoutForm';
import { SingularPaymentForm, SingularSubscriptionPaymentsInfoProps } from './SingularPaymentForm';
export const PaypleSingularSubscription = (props: Omit<SingularSubscriptionPaymentsInfoProps, 'onSubmit'>) => {
  const {
    paymentHashId,
    paymentInformation,
    productName
  } = props;
  const {
    showWidget
  } = usePayple();
  const {
    getValues
  } = useFormContext<PlanCheckoutFormSchemaType>();
  // const { mutateAsync: mutateZipCode } = useSingularUpdateZipCode();
  const showErrorDialog = useUnknownErrorDialog();
  const onSubmit = async () => {
    const finalPrice = paymentInformation.priceInfo?.finalPrice;
    if (typeof finalPrice !== 'number' || finalPrice <= 0) {
      showErrorDialog(new Error('Missing custom one-time payment price snapshot'));
      return;
    }
    try {
      await showWidget({
        orderId: paymentInformation.orderId,
        type: 'singularSubscription',
        comments: productName,
        totalAmount: finalPrice,
        paymentRequestHashId: paymentHashId,
        email: paymentInformation.paymentRequest.email,
        callbackUrl: SingularSubscriptionPaymentPaypleCallbackUrl,
        zipCode: getValues('zipCode')
      });
    } catch (e) {
      showErrorDialog(e);
    }
  };
  return <BusinessPaymentLayout title={props.businessName} data-sentry-element="BusinessPaymentLayout" data-sentry-component="PaypleSingularSubscription" data-sentry-source-file="SingularPaymentMethod.tsx">
      <SingularPaymentForm {...props} onSubmit={onSubmit} data-sentry-element="SingularPaymentForm" data-sentry-source-file="SingularPaymentMethod.tsx" />
    </BusinessPaymentLayout>;
};
export const TossPaySingularSubscription = (props: Omit<SingularSubscriptionPaymentsInfoProps, 'onSubmit'>) => {
  const {
    paymentInformation,
    paymentHashId,
    businessName,
    productName
  } = props;
  const router = useRouter();
  const showErrorDialog = useUnknownErrorDialog();
  const onSubmit = async () => {
    const finalPrice = paymentInformation.priceInfo?.finalPrice;
    if (typeof finalPrice !== 'number' || finalPrice <= 0) {
      showErrorDialog(new Error('Missing custom one-time payment price snapshot'));
      return;
    }
    try {
      window.TossPayments(process.env.NEXT_PUBLIC_SINGULAR_SUBSCRIPTION_TOSS_CLIENT_KEY).requestPayment(TossPaymentMethod.Card, {
        amount: finalPrice,
        orderId: paymentInformation.orderId,
        orderName: productName,
        customerName: businessName,
        customerEmail: paymentInformation.paymentRequest.email,
        windowTarget: 'self',
        successUrl: `https://${window.location.host}${SingularSubscriptionPaymentTossSuccessCallbackUrl}`,
        failUrl: `https://${window.location.host}/payment/singular/${paymentHashId}/fail?email=${encodeURIComponent(paymentInformation.paymentRequest.email)}`,
        useInternationalCardOnly: router.locale !== 'ko'
      });
    } catch (e) {
      showErrorDialog(e);
    }
  };
  return <BusinessPaymentLayout title={props.businessName} data-sentry-element="BusinessPaymentLayout" data-sentry-component="TossPaySingularSubscription" data-sentry-source-file="SingularPaymentMethod.tsx">
      <Head data-sentry-element="Head" data-sentry-source-file="SingularPaymentMethod.tsx">
        <script async src="https://js.tosspayments.com/v1"></script>
      </Head>
      <SingularPaymentForm {...props} onSubmit={onSubmit} data-sentry-element="SingularPaymentForm" data-sentry-source-file="SingularPaymentMethod.tsx" />
    </BusinessPaymentLayout>;
};